import {useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input, Space, Radio,} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { usePingfenUpdateQuery, usePingfenUpdateSaveMutation } from '../../store/BnsKeJiApi';
import MyEditor from '../../cpn/MyEditor';
import SketchSelect from '../sketch/SketchSelect';
function RateEdit(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [info,setInfo] = useState({
        'pf_xm_id': props.bxm_id,
        'pf_xm_name': props.bxm_name,
        'pf_xq_id': '',
        'pf_xq_name': '',
        'pf_bb_id': props.bxmbb_id,
        'pf_bb_name': props.bxmbb_name,
        'pf_num': '',
        'pf_uid': props.eu_id,
        'pf_uname': props.eu_name,
        'pf_id': props.pf_id
    }); 
    const {data,isSuccess} = usePingfenUpdateQuery({pf_id:props.pf_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    pf_content:data.Result.pf_content,
                    pf_num:data.Result.pf_num,
                    pf_xq_name:data.Result.pf_xq_name,
                    pf_name:data.Result.pf_name,
                    pf_state:data.Result.pf_state,
                    pf_bb_id:data.Result.pf_bb_id,
                })
                setInfo(prevState=>({...prevState,         
                    pf_content:data.Result.pf_content,                         
                    pf_num:data.Result.pf_num,  
                    pf_xq_id:data.Result.pf_xq_id,      
                    pf_xq_name:data.Result.pf_xq_name,   
                    pf_name:data.Result.pf_name,
                    pf_state:data.Result.pf_state, 
                    pf_bb_id:data.Result.pf_bb_id,  
                    pf_bb_name:data.Result.pf_bb_name,  
                    pf_yh_id:data.Result.pf_yh_id,  
                    pf_yh_name:data.Result.pf_yh_name,  
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = usePingfenUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改评分'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    goodsEdit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.pf_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item label="项目需求">
                        <Space>{info.pf_xm_name}-{info.pf_xq_name}</Space>
                    </Form.Item>
                    <SketchSelect
                        label='产品' 
                        bxm_id={props.bxm_id} 
                        wrapperCol={{ span: 10 }}
                        onChange={(e,f) => {
                            setInfo(prevState => ({ ...prevState, pf_bb_id:e,pf_bb_name:f }))}
                        }
                        name='pf_bb_id'
                    />
                    <Form.Item
                        name="pf_name"
                        label="名称"
                        wrapperCol={{ span: 20 }}
                        rules={[{ required: true, message: '请输入名称' }]}
                    >
                        <Input onChange={(e) => { setInfo(prevState => ({ ...prevState, pf_name: e.target.value }))}}/>
                    </Form.Item>
                    <Form.Item
                        name="pf_num"
                        label="评分"
                        wrapperCol={{ span: 10 }}
                        rules={[{ required: true, message: '请输入评分' }]}
                    >
                        <Input onChange={(e) => { setInfo(prevState => ({ ...prevState, pf_num: e.target.value }))}}/>
                    </Form.Item>
                    <Form.Item
                        name="pf_content"
                        label="备注"
                        wrapperCol={{ span: 20 }}
                    >
                        <MyEditor
                                onChange={(e) => {
                                    setInfo(prevState => ({ ...prevState, pf_content: e }))
                                }}
                            />
                    </Form.Item>
                    <Form.Item
                        name="pf_state"
                        label="名称"
                        wrapperCol={{ span: 10 }}
                        rules={[{ required: true, message: '请输入名称' }]}
                    >
                        <Radio.Group onChange={(e) => { setInfo(prevState => ({ ...prevState, pf_state: e.target.value }))}}>
                            <Radio value='1'>未实现</Radio>
                            <Radio value='2'>已实现</Radio>
                        </Radio.Group>
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default RateEdit